import {
  Box,
  Button,
  Center,
  Group,
  Loader,
  Modal,
  Stack,
  Text,
} from "@mantine/core";
import { useTranslation } from "react-i18next";

interface ExportAccountTransactionHistoryProps {
  opened: boolean;
  onClose: () => void;
  fileUrl: string;
  onDowload?: () => void;
  loading: boolean;
  title?: string;
}

const ExportAccountTransactionHistory = ({
  fileUrl,
  onClose,
  opened,
  onDowload,
  loading,
  title,
}: ExportAccountTransactionHistoryProps) => {
  const { t } = useTranslation();

  const canPreview = Boolean(fileUrl) && !loading;

  const renderContent = () => {
    if (loading) {
      return (
        <Center h="100%">
          <Stack align="center" spacing={8}>
            <Loader size="md" color="blue" />
            <Text size="sm" c="dimmed">
              {t("GENERATING_STATEMENT_PLEASE_WAIT")}
            </Text>
          </Stack>
        </Center>
      );
    }

    if (canPreview) {
      return (
        <iframe
          src={`${fileUrl}#toolbar=0`}
          title={t<string>("CONTRACT_INFORMATION")}
          width="100%"
          height="100%"
          style={{ border: "none" }}
        />
      );
    }

    return (
      <Center h="100%">
        <Text size="sm" c="dimmed">
          {t("NO_DATA_TO_DISPLAY")}
        </Text>
      </Center>
    );
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={title || t<string>("EXPORT_TRANSACTION_HISTORY")}
      size="lg"
      centered
      styles={{
        title: {
          fontWeight: 700,
        },
        body: { padding: 0 },
      }}
    >
      {/* ===== CONTENT ===== */}
      <Box style={{ height: "80vh" }}>{renderContent()}</Box>

      {/* ===== FOOTER ===== */}
      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          right: 0,
          zIndex: 2,
          padding: "16px",
          backgroundColor: "#fff",
          boxShadow: "0px -2px 8px rgba(0, 0, 0, 0.05)",
          width: "100%",
        }}
      >
        <Group position="right" w="100%">
          <Button
            disabled={loading || !fileUrl}
            loading={loading}
            sx={{
              color: "#FDFDFD",
              backgroundColor: "#2A81D0",
              "&:hover": { backgroundColor: "#2A81D0" },
              "&:active": { backgroundColor: "#2A81D0" },
              "&:focus": { outline: "none", boxShadow: "none" },
              padding: "10px 24px",
              borderRadius: "8px",
              width: "100%",
            }}
            onClick={onDowload}
          >
            {t("DOWNLOAD_PDF")}
          </Button>
        </Group>
      </Box>
    </Modal>
  );
};

export default ExportAccountTransactionHistory;
